import React from 'react';
import './About.css';

function About() {
  const stats = [
    { value: '5+', label: 'Years Experience', icon: '⚡' },
    { value: '2', label: 'Major Companies', icon: '🏢' },
    { value: '50+', label: 'Projects Delivered', icon: '🚀' },
    { value: '40%', label: 'Performance Gains', icon: '📈' },
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title reveal">About Me</h2>
        <p className="section-subtitle reveal">
          Turning complex challenges into elegant, scalable solutions
        </p>
        
        <div className="about-content">
          <div className="about-text reveal">
            <div className="about-text-block">
              <div className="about-line-accent" />
              <p>
                I'm a passionate Full Stack Software Engineer with 4+ years of experience building 
                scalable, cloud-native applications. Currently at <strong>OpenText</strong>, where I focus 
                on Kubernetes migration, microservices architecture, and AI-powered solutions.
              </p>
            </div>
            <div className="about-text-block">
              <div className="about-line-accent" />
              <p>
                My expertise spans backend development with <strong>Java & Spring Boot</strong>, frontend 
                development with <strong>Angular & React</strong>, and DevOps with <strong>Kubernetes & Docker</strong>. 
                I'm particularly passionate about distributed systems, AI/ML integration, and creating 
                elegant solutions to complex problems.
              </p>
            </div>
            <div className="about-text-block">
              <div className="about-line-accent" />
              <p>
                I've consistently delivered high-impact projects that improved performance by 
                <strong> 15–40%</strong> and reduced code defects through design pattern implementation 
                and thorough testing practices.
              </p>
            </div>
          </div>

          <div className="about-stats reveal">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="stat-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <span className="stat-icon">{stat.icon}</span>
                <h3 className="stat-value">{stat.value}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
